import type { LocaleMessageBundle } from '../../types'
import { salesMessages as salesFeatureMessages } from './sales'

export const salesMessages: LocaleMessageBundle = {
  vi: {
    ...salesFeatureMessages.vi,
  },
  en: {
    ...salesFeatureMessages.en,
  },
}
